import { IGoodgameClip } from "./clip/IGoodgameClip";

import Event = createjs.Event;
import Ticker = createjs.Ticker;


/**
 * singleton to manage time based animations for GoodgameBitmapClip
 */
export class AnimationManager {
    /** all registered clips that should be animated. */
    private clips: Map<IGoodgameClip, IGoodgameClip> = new Map<IGoodgameClip, IGoodgameClip>();

    /** rendertime of last frame. */
    private lastFrameTime: number;
    private isPlaying: boolean;
    /** timestamp after frame rendered. */
    private preTime: number;

    /**
     * Constructor
     *
     * @param stageRef reference to application stage
     *
     */
    constructor() {
    }

    /**
     * make animation manager ready for garbage-collector
     */
    public dispose(): void {
        this.clips = new Map<IGoodgameClip, IGoodgameClip>();
        Ticker.removeEventListener("tick", this.bindFunction( this.handleEnterFrame ));
    }

    /**
     * register new object to animate. animation will start
     * after adding
     *
     * @param clip instance of object to animate
     *
     */
    public register(clip: IGoodgameClip): void {
        if (!this.isPlaying) {
            Ticker.addEventListener("tick", this.bindFunction( this.handleEnterFrame ));
            this.preTime = Date.now();
            this.isPlaying = true;
        }
        this.clips.set(clip, clip);
    }

    /**
     * uregister object. animation will stop
     * after removing
     *
     * @param clip instance of object to remove
     *
     */
    public unregister(clip: IGoodgameClip): void {
        if (this.clips.get(clip)) {
            this.clips.delete(clip);

            let count: number = 0;

            for (let clp of Array.from(this.clips.values())) {
                count++;
            }

            if (count <= 0 && this.isPlaying) {
                Ticker.removeEventListener("tick", this.bindFunction( this.handleEnterFrame ));
                this.isPlaying = false;
            }
        }
    }

    private _pause: boolean = false;

    public set pause(value: boolean) {
        this._pause = value;
    }

    /**
     * updates all AnimatedEntities
     */
    private handleEnterFrame(event: Event): void {
        this.lastFrameTime = Date.now() - this.preTime;

        if (!event.paused) {
            for (let clip of Array.from(this.clips.values())) {
                let stage = clip.asDisplayObject().stage;
                if (stage && stage.tickEnabled && clip.visible && (!this._pause || (this._pause && clip.playOnPause))) {
                    clip.updateFrame(this.lastFrameTime);
                }
            }
        }
        this.preTime = Date.now();
    }
}
